import { useEffect, useState } from "react";
import { getData } from "../../Utils/apiController";
import { renderTextWithLinksAdvanced } from "../../Utils/uiUtils";
import { isEmpty, printDebugLog } from "../../Utils/utils";
import "./JsonLoader.css";
import { useLocation } from "react-router-dom";

const JsonLoader = () => {

    const location = useLocation();

    const [jsonData, setJsonData] = useState([]);
    const [title, setTitle] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);

        setLoading(true);

        printDebugLog("JsonLoader", "useEffect", location.state);

        const url = `${location.state?.url ?? "na"}.json`;

        getData({
            url: url,
            onResponse: (success, data) => {
                if (success) {
                    setJsonData(data.payLoad ?? []);
                    setTitle(data.title ?? "");
                } else {
                    setJsonData([]);
                    setTitle("");
                }
                setLoading(false);
            },
        });
    }, [location.state]);

    return (
        !loading && (
            <div id="terms" className="terms-section">
                <div className="terms-bg">
                    <div className="terms-bg-circle terms-bg-circle-primary" />
                    <div className="terms-bg-circle terms-bg-circle-accent" />
                </div>

                <div className="terms-container">
                    <div className="terms-content">
                        <h2 className="terms-heading">{title}</h2>

                        {(jsonData?.length ?? 0) > 0 &&
                            jsonData.map((term, index) => (
                                <div className="term-card" key={index}>
                                    {!isEmpty(term?.title) && (
                                        <p className="term-title">{term?.title}</p>
                                    )}

                                    {!isEmpty(term?.body) &&
                                        Array.isArray(term?.body) &&
                                        term?.body.length !== 0 &&
                                        term?.body.map((data, i) => (
                                            <p className="term-body" key={i}>
                                                {renderTextWithLinksAdvanced(data)}
                                            </p>
                                        ))}

                                    {!isEmpty(term?.points) &&
                                        Array.isArray(term?.points) &&
                                        term?.points.length !== 0 && (
                                            <ul className="term-points">
                                                {term?.points.map((data, i) => (
                                                    <li key={i}>{renderTextWithLinksAdvanced(data)}</li>
                                                ))}
                                            </ul>
                                        )}
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        )
    );
}
export default JsonLoader;